<template>
  <div class="floating_container">
    <titles :currentPage='currentLogin'></titles>
    <Alert ref="tips"></Alert>
    <div class="container_content">
      <banner></banner>
      <div class="content_wrapper">
        <div class="content_container_outline login">
          <div class="content_container login">
            <div class="content">
              <div class="content_top">
                <div class="content_title">Create account</div>

                <div class="switch" v-if="stateBtn" @click="switchFacebook()">
                  <router-link to="signup#other"><strong>Other log in options &gt;</strong></router-link>
                </div>
              </div>
              <div class="google_login" v-show="facebook">
                <div class="google_button" v-if="true" @click="handleGoogleLogin()">
                  <span class="google_logo"><img src="../assets/images/btn_google_light_normal_ios.png"/></span>
                  <span class="google_txt">Log in with Google</span>
                </div>
                <div class="login_separator" v-if="true"></div>
                <div class="yahoo_button" v-if="true" @click="handleYahooLogin()">
                  <span class="yahoo_logo"><img src="../assets/images/122.png"/></span>
                  <span class="google_txt">Log in with Yahoo</span>
                </div>
                <div class="login_separator" v-if="true"></div>
                <div class="facebook_button hover_effect" @click="handleFacebookLogin()">
                  <span class="facebook_logo"><img src="../assets/images/facebook_logo.png"/></span>
                  <span class="facebook_text">Log in with Facebook</span>
                </div>
                
                <div class="login_separator">or</div>
              
                <div class="with_email" @click="switchEmail()">
                  <router-link to="signup#email">Sign up with email</router-link>
                </div>
              </div>
              <div class="email_login" v-if="emailLogin">
                <input type="text" maxlength="45" class="form_field" placeholder="Email" v-model="email" autofocus
                      @blur="emailCheck()" ref="email">
                <input type="password" maxlength="16" class="form_field" placeholder="Password" v-model="password"
                      @blur="passwordCheck()" ref="password">
                <button class="email_button hover_effect" @click="handleEmailSignUp">Sign up</button>

                <div class="agreement" v-if="isFromEU">
                  <input v-model="checked" type="checkbox" id="check-box">
                  <label id="check-box-label" for="check-box">I would like to receive email updates, notifications and
                    special promotional
                    offers from $__BRAND_NAME.</label>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="alt_option">Already have an account?
            <router-link to="login"><strong>Log in</strong></router-link>
          </div>
      </div>
    </div>

    <!-- <div class="protocol" v-if="emailLogin && !isFromEU ">By entering my email here, I have read and agree to the <a
      target="_blank" href="$__BASE_URL_WWW/privacy">Privacy Policy</a>
      and agree to receive email updates, notifications, and special promotional offers from $__BRAND_NAME.
    </div> -->

    <div class="protocol" v-if="emailLogin && isFromEU ">By entering my email here, I have read and agree to the
      <a target="_blank" href="$__BASE_URL_WWW/terms">Terms and Conditions </a> and <a target="_blank" href="$__BASE_URL_WWW/privacy">Privacy Policy.</a>
    </div>


  </div>
</template>

<script>
  import api from '../api/account.js'
  import validate from '../utils/validate.js'
  import {mapMutations, mapState} from 'vuex'
  import auth from '../utils/auth.js'
  import trackers from '../utils/trackers.js'
  import Alert from '../components/Alert.vue'

  export default {
    data () {
      return {
        email: '',
        password: '',
        currentLogin: 'signupText',
        isFromEU: false,
        checked: false,
        facebook: true,
        emailLogin: false,
        isValidEmail: false,
        isValidPassword: false,
        stateBtn: false,
        currentDomain: window.location.host.split('.')[1] + '.com',
      }
    },
    components: {Alert},
    computed: mapState([
      'platform',
      'userLocationCode',
      'accountConfirmed'
    ]),

    methods: {
      ...mapMutations([
        'loggingStatus',
        'faceBookLogin',
        'googleLogin',
        'yahooLogin'
      ]),
      handleGoogleLogin(){
        this.googleLogin()
      },
      handleYahooLogin(){
        this.yahooLogin()
      },
      handleFacebookLogin () {
        this.faceBookLogin()
      },
      switchEmail () {
        this.facebook = false
        this.emailLogin = true
        this.stateBtn = true
        this.isFromEU = this.userLocationCode === 1
      },

      switchFacebook () {
        this.facebook = true
        this.emailLogin = false
        this.stateBtn = false
      },

      emailCheck () {
        this.isValidEmail = validate.email(this.email.trim(), res => {
          this.$refs.tips.popTips(res)
        })
      },
      passwordCheck () {
        if (this.isValidEmail) {
          this.isValidPassword = validate.password(this.password.trim(), res => {
            this.$refs.tips.popTips(res)
          })
        }
      },
      getUrlParam () {
        if (location.href.includes('direct') && location.href.includes('email')) {
          this.switchEmail()
          this.email = validate.getQuery()
        }
      },
      handleEmailSignUp () {
        this.emailCheck()
        this.passwordCheck()

        if (this.isValidEmail && this.isValidPassword) {
          let data = {
            version: Math.random(),
            email: this.email,
            pwd: auth.rsa(this.password),
            email_promotion_allowed: !this.isFromEU || (this.isFromEU && this.checked)
          }
          api.singUp(data)
            .then(res => {
              if (res.data.Value && res.data.State === 1) {
                this.accountConfirmed = true
                this.loggingStatus()
                auth.setCookie('userEmail', this.email, 30)
                trackers.signSucceed(this.platform)
              } else {
                this.$refs.tips.popTips(res.data.Message)
                trackers.signFailed()
              }

              try {
                var evt = 'sign_up';
                var params = {
                  "result": res.data.Value && res.data.State === 1
                };
                console.log('ReportEvent', evt, params);
                gtag('event', evt, params);
              } catch (err) {
                console.error('ReportEventFailed', err);
              }

            })
          trackers.statisticsSign('signup_click', 'signup_click')
        }
      }
    },

    mounted () {
      this.getUrlParam()
      trackers.statisticsSign('signup_view', 'view')
    }
  }
</script>

<style scoped>
  @import '../assets/css/main.css';

  #check-box-label {
    padding-left: 5px
  }

  #check-box {
    vertical-align: middle;
    margin: 0 0 1px 0;
  }

  .agreement {
    color: #fff;
    font-size: 12px;
    vertical-align: middle;
    width: 100%;
    position: absolute;
    right: 0;
    top: 165px;
  }

  .protocol {
    width: 100%;
    color: #86a5c3;
    min-width: 0;
    padding: 15px 0;
    text-align: left;
    font-size: 12px;
  }

  .protocol a {
    color: #86a5c3;

  }
</style>



// WEBPACK FOOTER //
// src/views/Signup.vue